<template>
    <!-- The end of a menu entry: says that work is waiting on that page, and
         never starts anything (docs/update-designs-proposal.md §5.7). -->
    <v-tooltip v-if="indicator.kind != 'none'" location="end" :disabled="!tooltip" :open-delay="200">
        <template v-slot:activator="{ props }">
            <span v-bind="props" class="menu-indicator d-inline-flex align-center">
                <v-chip v-if="indicator.kind == 'pill'" size="x-small" variant="flat" color="accent"
                    class="pill pit-mono">
                    {{ indicator.text }}
                </v-chip>
                <span v-else-if="indicator.kind == 'dot'" class="dot"></span>
                <v-progress-circular v-else-if="indicator.kind == 'spinner'" indeterminate color="accent" size="18"
                    width="2.5" />
                <v-icon v-else-if="indicator.kind == 'lock'" size="18" color="grey">mdi-lock-outline</v-icon>
                <v-icon v-else-if="indicator.kind == 'alert'" size="20" color="error">mdi-alert-circle</v-icon>
            </span>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script setup>
defineProps({
    // { kind: "none" | "pill" | "dot" | "spinner" | "lock" | "alert", text }
    indicator: { type: Object, default: () => ({ kind: "none" }) },
    tooltip: { type: String, default: "" },
})
</script>

<style scoped>
.pill {
    font-weight: 500;
    font-variant-numeric: tabular-nums;
}

.dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: rgb(var(--v-theme-accent));
    display: inline-block;
}
</style>
